import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "./Button";

const LocalServicePage = ({ town }) => {
  const navigate = useNavigate();

  return (
    <main className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-green-700 mb-4">
        Lawn Care & Landscaping in {town}, NJ
      </h1>
      <p className="text-gray-700 mb-6">
        LawnSmartPro proudly provides professional lawn maintenance,
        fertilization, irrigation repairs, and landscaping to homeowners in{" "}
        {town}. Book a fast online quote today.
      </p>

      <Button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
        Get Your Free Estimate
      </Button>
      <div className="mt-6">
        <button
          onClick={() => navigate(-1)}
          className="text-green-700 text-sm mb-6 underline hover:text-green-900"
        >
          ← Back
        </button>
      </div>
    </main>
  );
};

export default LocalServicePage;
